<template lang="pug">
#app(:key="$route.meta.layout")
  //- LAYOUT A: Der Code-Desktop (mit Sidebar und Splitter)
  template(v-if="$route.meta.layout === 'desktop'")
    .browser-window
      //- Gemeinsamer Header
      .window-header
        .controls
          .dot.red
          .dot.yellow
          .dot.green
          .tab {{currentTabName}}
        div
          icon(name="home", @click="$router.push({name:'home'})")
      
      .window-content
        Splitter(style="width: 100%" stateKey="my-sidebar-resizer" stateStorage="local")
          SplitterPanel(:size="280" :minSize="220")
            aside.sidebar
              FileTree(:items="menuStructure", @select="goto")
          SplitterPanel(:key="$route.fullPath")
            main.window-body
              router-view

  //- LAYOUT B: Vollbild-Views (Tools/Demos - jetzt auch mit Header)
  template(v-else)
    .fullscreen-app
      //- Der gleiche Header wie oben, aber direkt über der App
      .window-header
        .controls
          .dot.red
          .dot.yellow
          .dot.green
          .tab {{currentTabName}}
        div
          icon(name="home", @click="$router.push({name:'home'})")
      
      //- Der Inhalt füllt den Rest unter dem Header aus
      .window-body
        router-view(:key="$route.fullPath")
</template> 

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import Icon from "@/components/Icon.vue";
import TopHeader from "@/components/TopHeader.vue";
import Navi from "@/components/Navi.vue";
import XFooter from "@/components/Footer.vue";
import FileTree from '@/components/FileTree.vue';
import Splitter from 'primevue/splitter';
import SplitterPanel from 'primevue/splitterpanel';
import api from "./api";
import { openDB } from "idb";
// import * as crypto from "crypto";
// import Login from '@/components/Login.vue';
export default {
  components: {
    Icon,
    TopHeader,
    Navi,
    XFooter,
    FileTree,
    Splitter,
    SplitterPanel
    // Login
  },
  data() {
    return {
      toLogin: true,
      showNavi: false,
    };
  },
  computed: {
    ...mapGetters({
      menuStructure: "navi/items",
    }),
    isDesktopLayout() {
    // Wenn kein Meta-Tag gesetzt ist, Standard auf Fullscreen (für Demos)
    // oder umgekehrt, je nachdem was häufiger ist.
    return this.$route.meta.layout === 'desktop';
  },
  currentTabName() {
    return this.$route.name + '.ts';
  },
    isAuthenticated() {
      return true;
    },
  },
  metaInfo: {
    title: "Softwareentwicklung",
    titleTemplate: "Gabriel Gnatowski, %s",
    meta: [
      {
        description:
          "Als leidenschaftlicher Entwickler mit Fachkenntnissen in Node.js, JavaScript und TypeScript bringe ich innovative Ideen zum Leben. Mit einem Auge für Details und einer klaren Fokussierung auf effiziente Lösungen strebe ich danach, nutzerfreundliche und skalierbare Anwendungen zu entwickeln. Meine Begeisterung für Technologie und kontinuierliches Lernen treibt mich an, stets auf dem neuesten Stand zu bleiben und die besten Programmierpraktiken in meine Arbeit einzubringen. Ich freue mich darauf, Ihre Projekte mit Expertise und Kreativität zu unterstützen",
      },
      {
        "google-site-verification":
          "gNZdOFTlRb5m-8sKm5HpoKmW3c5E-dOpOybps0yllvs",
      },
    ],
    link: [{ rel: "favicon", href: "favicon-32x32.png" }],
  },
  methods: {
    async registerDevice(deviceId) {
      await fetch("/api/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          device_id: deviceId,
          user_agent: navigator.userAgent,
          platform: navigator.platform,
        }),
      });
    },
    goto(target) {
      console.log('GOTO', target);
      this.$router.push({ name: target });
    },
    generateDeviceId() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    async getOrCreateDeviceId() {
      const db = await openDB("myapp", 1, {
        upgrade(db) {
          if (!db.objectStoreNames.contains("settings")) {
            db.createObjectStore("settings");
          }
        },
      });

      // Key "device_id" abfragen
      let deviceId = await db.get("settings", "device_id");

      if (!deviceId) {
        deviceId = this.generateDeviceId();

        // In IndexedDB speichern
        await db.put("settings", deviceId, "device_id");

        // Server registrieren
        await this.registerDevice(deviceId);
      }

      return deviceId;
    },
  },
  async mounted() {
    console.log(this);
    const device = await this.getOrCreateDeviceId();
    console.log("DEVICE:", device);
    localStorage.setItem("device", device);
  },
};
</script>
<style lang="less">
@import "./shared.less";

html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-flow: column;
}

#app {
  flex: 1 0;
  display: flex;
  flex-flow: column nowrap;
  align-items: stretch;
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: @c3;
  background-color: #fff;
  position: relative;
  height: 100%;
}

.menu {
  position: absolute;
  right: 0.75rem;
  top: 0.75rem;
  color: black;
  border: 1px solid gray;
  width: 24px;
  height: 24px;
  padding: 4px;
  background: #fff;
}
#content {
  flex: 1 0;
  display: flex;
  overflow: hidden;
}

.browser-window {
  flex: 1 1 auto;
  display: flex;
  flex-flow: column;
}
.window-header {
  padding: 0.5rem 1rem;
  background-color: #345;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.controls {
  display: flex;
  align-items: center;
}
.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin: 0.25rem;
  @media (min-width: 768px) {
    width: 20px;
    height: 20px;
    margin: 0.5rem;
  }
}
.red {
  background-color: red;
}
.yellow {
  background-color: yellow;
}
.green {
  background-color: green;
}
.tab {
  color: white;
  font-size: 1.5rem;
  margin: 0 2rem;
}
.window-content {
  display: flex;
  flex: 1 1 auto;
  overflow: auto;
  height: 0;
  @media (max-width: 768px) {
    flex-direction: column;
  }
}
.p-splitter {
  height: 100%;
}
.sidebar {
  // width: 280px;
  flex: 1 0;
  background: #1e2a38; // Etwas dunkler als der Body für Kontrast
  font-size: 1rem;
  padding: 1rem 0;
  border-right: 1px solid #345;

  @media (max-width: 768px) {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #345;
  }

  .explorer-title {
    padding: 0 1rem 0.5rem;
    font-size: 0.7rem;
    color: #888;
    text-transform: uppercase;
    letter-spacing: 1px;
  }
}
.fullscreen-app {
  flex: 1 1;
  display: flex;
  flex-flow: column;
  overflow: hidden;
  // height: 100%;
  font-size: 1rem;
  padding: 0;
  margin: 0;
  background: #234;
  color: #fff;
}

.window-body {
  flex: 1 1;
  display: flex;
  flex-flow: column;
  overflow: hidden;
  // height: 100%;
  font-size: 1rem;
  padding: 0;
  margin: 0;
  background: #234;
  color: #fff;
  font-family: "Fira Code", "Courier New", monospace; // Wichtig für Coding-Look

  @media (min-width: 768px) {
    font-size: 1.5rem;
  }
}

@media print {
  html,
  body {
    height: auto !important;
  }
  #app {
    height: auto !important;
  }
  .menu {
    display: none;
  }

}
</style>
